import { baseFormat } from './DateUtils39.js';

const formatDate = (date, options) => {
    return baseFormat(date, options);
};

export { formatDate };
